module.exports = "/images/subscription-waiting.webp?42bc03b97b6468fcc7129f0d2826138f";